import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <title id="Arrow-Fill-Right">{props.title || 'Arrow-Fill-Right'}</title>
      <g>
        <path d="M412.6 248.4c2.9 2.3 4.1 5.3 4.1 8.2 0 2.9-1.2 6.5-4.1 8.2l-295.6 242.7c-2.9 2.4-7 2.9-11.1 1.2-3.5-1.8-5.9-5.3-5.9-9.4v-485.5c0-4.1 2.3-7.6 5.9-9.4 4.1-1.8 8.2-1.2 11.1 1.2l295.6 242.8z" />
      </g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/arrowFillRight.js